import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import GeneralServices from '../../app/service/generalServices'
import ConstantsUtil from '../../context/constantsUtil'
import TableFilters from '../tableFilters'

class DDABoletoPagamentoTable extends React.Component {

    constructor(){
        super();
        this.dt = React.createRef();
        this.tableFilters = new TableFilters();
    }

    state = {

    }

    formatarCnpj = (value) => {
        if(!value) return ''
        const apenasNumeros = value.replace(/\D/g, '')
        if(apenasNumeros.length !== 14) return value
        return apenasNumeros.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
    }

    render (){

        const dataDisponibilizacaoDDAFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedDataDisponibilizacaoDDA,
            this.props.list,
            "selectedDataDisponibilizacaoDDA",
            (name, value) => this.setState({[name]: value}),
            'dataDisponibilizacaoDDA',
            '100%',
            "Data de Disponibilização no DDA"
        )

        const dataVencimentoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedDataVencimento,
            this.props.list,
            "selectedDataVencimento",
            (name, value) => this.setState({[name]: value}),
            'dataVencimento',
            '100%',
            "Data Vencimento"
        )

        const dataHoraImportacaoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedDataHoraImportacao,
            this.props.list,
            "selectedDataHoraImportacao",
            (name, value) => this.setState({[name]: value}),
            'dataHoraImportacao',
            '100%',
            "Data/Hora Importação"
        )

        const origemFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedOrigem,
            this.props.list,
            "selectedOrigem",
            (name, value) => this.setState({[name]: value}),
            'origem',
            '100%',
            "Origem"
        )

        const linhaDigitavelFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedLinhaDigitavel,
            this.props.list,
            "selectedLinhaDigitavel",
            (name, value) => this.setState({[name]: value}),
            'linhaDigitavel',
            '100%',
            "Linha Digitável"
        )

        const nomeBeneficiarioFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedNomeBeneficiario,
            this.props.list,
            "selectedNomeBeneficiario",
            (name, value) => this.setState({[name]: value}),
            'nomeBeneficiario',
            '100%',
            "Beneficiário"
        )

        const cnpjBeneficiarioFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedCnpjBeneficiario,
            this.props.list,
            "selectedCnpjBeneficiario",
            (name, value) => this.setState({[name]: value}),
            'cnpjBeneficiario',
            '100%',
            "CNPJ Beneficiário"
        )

        const numeroDocumentoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedNumeroDocumento,
            this.props.list,
            "selectedNumeroDocumento",
            (name, value) => this.setState({[name]: value}),
            'numeroDocumento',
            '100%',
            "Nº Documento"
        )

        const valorFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedValor,
            this.props.list,
            "selectedValor",
            (name, value) => this.setState({[name]: value}),
            'valor',
            '100%',
            "Valor"
        )

        return (
            <div>

            <DataTable
                ref={this.dt}
                value={this.props.list}
                className="p-datatable-sm small-font"
                rowHover
                showGridlines
                style={{ maxWidth: '100vw' }}
                scrollable
                scrollHeight="500px"
                loading={this.props.loading}
                dataKey="id"
                emptyMessage="Nenhum Boleto encontrado."
                paginator rows={ConstantsUtil.initialTableQuantityOption}
                paginatorTemplate={GeneralServices.tablePaginatorTemplate(ConstantsUtil.initialTableQuantityOption, this.props.list ? this.props.list.length : '')}
                currentPageReportTemplate="Mostrando de {first} ao {last} de {totalRecords} boletos"
            >

            <Column field="dataDisponibilizacaoDDA" header="Data de Disponibilização no DDA"
                sortable sortField='dataDisponibilizacaoDDAOrdenacao'
                style ={ {width: '110px'} }
                filter filterElement={dataDisponibilizacaoDDAFilterElement}
            />

            <Column field="dataVencimento" header="Data Vencimento"
                sortable sortField="dataVencimentoOrdenacao"
                style ={ {width: '120px'} }
                filter filterElement={dataVencimentoFilterElement}
            />

            <Column field="dataHoraImportacao" header="Data/Hora Importação"
                sortable sortField="dataHoraImportacaoOrdenacao"
                style ={ {width: '150px'} }
                filter filterElement={dataHoraImportacaoFilterElement}
            />

            <Column field="origem" header="Origem" sortable
                style ={ {width: '100px'} }
                filter filterElement={origemFilterElement}
            />

            <Column field="linhaDigitavel" header="Linha Digitável" sortable
                style ={ {width: '220px'} }
                filter filterElement={linhaDigitavelFilterElement}
            />

            <Column field="nomeBeneficiario" header="Beneficiário" sortable
                style ={ {width: '220px'} }
                filter filterElement={nomeBeneficiarioFilterElement}
            />

            <Column field="cnpjBeneficiario" header="CNPJ Beneficiário" sortable
                style ={ {width: '150px'} }
                body = {rowData => this.formatarCnpj(rowData.cnpjBeneficiario)}
                filter filterElement={cnpjBeneficiarioFilterElement}
            />

            <Column field="numeroDocumento" header="Nº Documento" sortable
                style ={ {width: '130px'} }
                filter filterElement={numeroDocumentoFilterElement}
            />

            <Column field="valor" header="Valor" sortable
                style ={ {width: '110px'} }
                body = {rowData => GeneralServices.valueBodyTemplateWithCifrao(rowData.valor)}
                filter filterElement={valorFilterElement}
            />

            </DataTable>

            </div>
        )
    }

}

export default DDABoletoPagamentoTable
